class ArticleTableOfContents {
  constructor(article) {
    this.article = article;
    this.content = article.querySelector('[data-article-content]');
    this.body = article.querySelector('[data-article-body]');
    this.desktopToc = article.querySelector('[data-article-toc]');
    this.desktopList = article.querySelector('[data-article-toc-list]');
    this.mobileToc = article.querySelector('[data-article-mobile-toc]');
    this.mobileToggle = article.querySelector('[data-article-mobile-toc-toggle]');
    this.mobilePanel = article.querySelector('[data-article-mobile-toc-panel]');
    this.mobileClose = article.querySelector('[data-article-mobile-toc-close]');
    this.mobileList = article.querySelector('[data-article-mobile-toc-list]');
    this.mobileCurrent = article.querySelector('[data-article-mobile-toc-current]');
    this.mobileCurrentNumber = article.querySelector('[data-article-mobile-toc-current-number]');
    this.hero =
      article.querySelector('[data-article-hero]') ||
      article.querySelector('.article-template__hero-container');

    this.mobileQuery = window.matchMedia('(max-width: 989px)');

    this.raf = null;
    this.activeIndex = 0;

    this.programmaticScroll = false;
    this.programmaticScrollIndex = null;
    this.programmaticScrollFrame = null;
    this.programmaticScrollStartedAt = 0;
    this.programmaticScrollLastY = window.scrollY;
    this.programmaticScrollStableFrames = 0;

    if (!this.content || !this.desktopList || !this.mobileList) return;

    this.headings = Array.from(
      this.content.querySelectorAll('h2')
    ).filter((heading) => {
      return heading.textContent.trim().length > 0;
    });

    if (!this.headings.length) return;

    this.article.classList.add('article-template--has-toc');
    this.article.dataset.articleTocInitialized = 'true';

    this.desktopLinks = [];
    this.mobileLinks = [];

    this.prepareHeadings();
    this.buildDesktopToc();
    this.buildMobileToc();
    this.bindEvents();
    this.update();
  }

  prepareHeadings() {
    const usedIds = new Set();

    this.headings.forEach((heading, index) => {
      const originalId = heading.id;

      const baseId =
        originalId ||
        this.slugify(heading.textContent) ||
        `article-section-${index + 1}`;

      let finalId = baseId;
      let counter = 2;

      while (
        usedIds.has(finalId) ||
        (
          document.getElementById(finalId) &&
          document.getElementById(finalId) !== heading
        )
      ) {
        finalId = `${baseId}-${counter}`;
        counter += 1;
      }

      heading.id = finalId;
      heading.setAttribute('tabindex', '-1');

      usedIds.add(finalId);
    });
  }

  buildDesktopToc() {
    this.desktopList.innerHTML = '';

    this.headings.forEach((heading, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');

      item.className = 'article-template__toc-item';

      link.className = 'article-template__toc-link';
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.articleTocIndex = index;

      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollToHeading(index);
      });

      item.appendChild(link);
      this.desktopList.appendChild(item);
      this.desktopLinks.push(link);
    });

    if (this.desktopToc) {
      this.desktopToc.hidden = false;
    }
  }

  buildMobileToc() {
    this.mobileList.innerHTML = '';

    this.headings.forEach((heading, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      const number = document.createElement('span');
      const text = document.createElement('span');

      item.className = 'article-template__mobile-toc-item';

      link.className = 'article-template__mobile-toc-link';
      link.href = `#${heading.id}`;
      link.dataset.articleMobileTocIndex = index;

      number.className = 'article-template__mobile-toc-index';
      number.textContent = index + 1;

      text.className = 'article-template__mobile-toc-text';
      text.textContent = heading.textContent.trim();

      link.appendChild(number);
      link.appendChild(text);

      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.setMobileOpen(false);
        this.scrollToHeading(index);
      });

      item.appendChild(link);
      this.mobileList.appendChild(item);
      this.mobileLinks.push(link);
    });
  }

  bindEvents() {
    window.addEventListener(
      'scroll',
      () => this.requestUpdate(),
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => this.requestUpdate()
    );

    /*
     * Permette di scorrere l'indice desktop con la rotellina
     * del mouse o con il trackpad.
     *
     * Quando l'indice raggiunge l'inizio o la fine,
     * lo scroll torna automaticamente alla pagina.
     */
if (this.desktopToc) {
  this.desktopToc.addEventListener(
    'wheel',
    (event) => {
      if (
        this.mobileQuery.matches ||
        this.desktopToc.hidden
      ) {
        return;
      }

      /*
       * Blocca completamente lo scroll della pagina
       * quando il cursore si trova sopra l'indice.
       */
      event.preventDefault();
      event.stopPropagation();

      const maxScroll =
        this.desktopToc.scrollHeight -
        this.desktopToc.clientHeight;

      if (maxScroll <= 0) return;

      let scrollAmount = event.deltaY;

      /*
       * Normalizza il movimento della rotellina
       * tra mouse e trackpad.
       */
      if (event.deltaMode === 1) {
        scrollAmount *= 16;
      } else if (event.deltaMode === 2) {
        scrollAmount *= this.desktopToc.clientHeight;
      }

      const nextScrollTop =
        this.desktopToc.scrollTop + scrollAmount;

      this.desktopToc.scrollTop = Math.max(
        0,
        Math.min(nextScrollTop, maxScroll)
      );
    },
    { passive: false }
  );
}

    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener(
        'change',
        () => this.update()
      );
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(
        () => this.update()
      );
    }

    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', () => {
        const isOpen =
          this.mobileToc &&
          this.mobileToc.dataset.open === 'true';

        this.setMobileOpen(!isOpen);
      });
    }

    if (this.mobileClose) {
      this.mobileClose.addEventListener('click', () => {
        this.setMobileOpen(false);
      });
    }

    document.addEventListener('click', (event) => {
      if (
        !this.mobileToc ||
        this.mobileToc.hidden
      ) {
        return;
      }

      if (this.mobileToc.contains(event.target)) return;

      this.setMobileOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      this.setMobileOpen(false);
    });
  }

  requestUpdate() {
    if (this.raf) return;

    this.raf = window.requestAnimationFrame(() => {
      this.raf = null;
      this.update();
    });
  }

  update() {
    if (
      this.programmaticScroll &&
      this.programmaticScrollIndex !== null
    ) {
      this.setActiveIndex(
        this.programmaticScrollIndex
      );

      this.updateMobileVisibility();
      return;
    }

    const nextActiveIndex =
      this.getActiveIndexFromScroll();

    this.setActiveIndex(nextActiveIndex);
    this.updateMobileVisibility();
  }

  getActiveIndexFromScroll() {
    const headerHeight = this.getHeaderHeight();
    const isMobile = this.mobileQuery.matches;

    const activationLine =
      headerHeight + (isMobile ? 96 : 32);

    const lookAheadTolerance =
      isMobile ? 140 : 0;

    let nextActiveIndex = 0;

    this.headings.forEach((heading, index) => {
      const top =
        heading.getBoundingClientRect().top;

      if (top <= activationLine) {
        nextActiveIndex = index;
      }
    });

    if (lookAheadTolerance > 0) {
      const nextHeading =
        this.headings[nextActiveIndex + 1];

      if (nextHeading) {
        const nextTop =
          nextHeading.getBoundingClientRect().top;

        if (
          nextTop > activationLine &&
          nextTop - activationLine <= lookAheadTolerance
        ) {
          nextActiveIndex += 1;
        }
      }
    }

    const isAtBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 4;

    if (isAtBottom) {
      nextActiveIndex =
        this.headings.length - 1;
    }

    return nextActiveIndex;
  }

  setActiveIndex(index) {
    if (
      index < 0 ||
      index >= this.headings.length
    ) {
      return;
    }

    this.activeIndex = index;

    this.desktopLinks.forEach(
      (link, linkIndex) => {
        const item = link.closest(
          '.article-template__toc-item'
        );

        const isActive =
          linkIndex === index;

        if (item) {
          item.classList.toggle(
            'is-active',
            isActive
          );
        }

        if (isActive) {
          link.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          link.removeAttribute(
            'aria-current'
          );
        }
      }
    );

    this.mobileLinks.forEach(
      (link, linkIndex) => {
        const item = link.closest(
          '.article-template__mobile-toc-item'
        );

        const isActive =
          linkIndex === index;

        if (item) {
          item.classList.toggle(
            'is-active',
            isActive
          );
        }

        if (isActive) {
          link.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          link.removeAttribute(
            'aria-current'
          );
        }
      }
    );

    if (this.mobileCurrent) {
      this.mobileCurrent.textContent =
        this.headings[index]
          .textContent
          .trim();
    }

    if (this.mobileCurrentNumber) {
      this.mobileCurrentNumber.textContent =
        `${index + 1}/${this.headings.length}`;
    }
  }

  updateMobileVisibility() {
    if (
      !this.mobileToc ||
      !this.body
    ) {
      return;
    }

    if (!this.mobileQuery.matches) {
      this.mobileToc.hidden = true;

      this.mobileToc.classList.remove(
        'is-stopped'
      );

      this.setMobileOpen(false);
      return;
    }

    const headerOffset =
      this.getHeaderHeight();

    const bodyRect =
      this.body.getBoundingClientRect();

    const heroBottom =
      this.hero
        ? this.hero.getBoundingClientRect().bottom
        : bodyRect.top;

    const hasPassedHero =
      heroBottom <= headerOffset + 1;

    const hasReachedBodyEnd =
      bodyRect.bottom <= window.innerHeight;

    this.mobileToc.hidden =
      !hasPassedHero;

    this.mobileToc.classList.toggle(
      'is-stopped',
      hasPassedHero && hasReachedBodyEnd
    );

    if (!hasPassedHero) {
      this.setMobileOpen(false);
    }
  }

  setMobileOpen(open) {
    if (
      !this.mobileToc ||
      !this.mobileToggle ||
      !this.mobilePanel
    ) {
      return;
    }

    this.mobileToc.dataset.open =
      open ? 'true' : 'false';

    this.mobileToggle.setAttribute(
      'aria-expanded',
      open ? 'true' : 'false'
    );

    this.mobilePanel.hidden = !open;
  }

  scrollToHeading(index) {
    const heading =
      this.headings[index];

    if (!heading) return;

    const isMobile =
      this.mobileQuery.matches;

    const offset =
      this.getHeaderHeight() +
      (isMobile ? 20 : 24);

    const top =
      window.scrollY +
      heading.getBoundingClientRect().top -
      offset;

    this.startProgrammaticScroll(index);

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth',
    });

    window.history.replaceState(
      null,
      '',
      `#${heading.id}`
    );
  }

  startProgrammaticScroll(index) {
    this.stopProgrammaticScrollWatcher();

    this.programmaticScroll = true;
    this.programmaticScrollIndex = index;
    this.programmaticScrollStartedAt =
      Date.now();

    this.programmaticScrollLastY =
      window.scrollY;

    this.programmaticScrollStableFrames = 0;

    this.setActiveIndex(index);
    this.watchProgrammaticScroll();
  }

  watchProgrammaticScroll() {
    const maxDuration =
      this.mobileQuery.matches
        ? 1800
        : 1400;

    const currentY =
      window.scrollY;

    const delta =
      Math.abs(
        currentY -
        this.programmaticScrollLastY
      );

    const elapsed =
      Date.now() -
      this.programmaticScrollStartedAt;

    if (delta < 0.5) {
      this.programmaticScrollStableFrames += 1;
    } else {
      this.programmaticScrollStableFrames = 0;
    }

    this.programmaticScrollLastY =
      currentY;

    if (
      this.programmaticScrollStableFrames >= 8 ||
      elapsed > maxDuration
    ) {
      this.finishProgrammaticScroll();
      return;
    }

    this.programmaticScrollFrame =
      window.requestAnimationFrame(() => {
        this.watchProgrammaticScroll();
      });
  }

  finishProgrammaticScroll() {
    const finalIndex =
      this.programmaticScrollIndex;

    this.stopProgrammaticScrollWatcher();

    this.programmaticScroll = false;
    this.programmaticScrollIndex = null;

    if (finalIndex !== null) {
      this.setActiveIndex(finalIndex);

      const heading =
        this.headings[finalIndex];

      if (heading) {
        try {
          heading.focus({
            preventScroll: true,
          });
        } catch (error) {
          heading.focus();
        }
      }
    }
  }

  stopProgrammaticScrollWatcher() {
    if (this.programmaticScrollFrame) {
      window.cancelAnimationFrame(
        this.programmaticScrollFrame
      );

      this.programmaticScrollFrame = null;
    }
  }

  getHeaderHeight() {
    const header =
      document.querySelector(
        '.section-header'
      );

    return header
      ? header.offsetHeight
      : 0;
  }

  slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}

function initArticleTableOfContents() {
  document
    .querySelectorAll('.article-template')
    .forEach((article) => {
      if (
        article.dataset.articleTocInitialized ===
        'true'
      ) {
        return;
      }

      new ArticleTableOfContents(article);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initArticleTableOfContents
  );
} else {
  initArticleTableOfContents();
}

document.addEventListener(
  'shopify:section:load',
  initArticleTableOfContents
);